/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import {
  TextField,
  Button,
  Typography,
  Box,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { addSnackbar } from '../../redux/reducers/ducks/SnackbarDuck';
import {
  addIngredientUnitApi,
  deleteIngredientUnitApi
} from '../../api/ingredients/ingredientsApi';

const AddEditUnit = ({ addPopup, setAddPopup, callFunc }) => {
  const dispatch = useDispatch();

  const { register, handleSubmit, reset } = useForm({
    defaultValues: {}
  });

  useEffect(() => {
    if (addPopup.id) {
      reset();
    }
  }, [addPopup.isOpen]);

  const onSubmit = async (data) => {
    const res = await addIngredientUnitApi(data);
    if (res.status == 200) {
      dispatch(
        addSnackbar({
          message: 'New Unit Created',
          type: 'success'
        })
      );
      handleClose();
      callFunc();
    } else {
      dispatch(
        addSnackbar({
          message: res.response.data.message,
          type: 'error'
        })
      );
    }
  };

  const handleClose = () => {
    setAddPopup({ isOpen: false });
    reset();
  };

  return (
    <Box>
      <Container>
        <Dialog open={addPopup.isOpen} onClose={handleClose}>
          <Box
            sx={{
              textAlign: 'center',
              width: 'min(100% -30px, 700px)',
              marginInline: 'auto'
            }}>
            <DialogTitle id="alert-dialog-title">
              {addPopup.id ? (
                <Typography color="#FFA500" fontWeight="700">
                  Delete Unit
                </Typography>
              ) : (
                <Typography color="#FFA500" fontWeight="700">
                  Add New Unit
                </Typography>
              )}
            </DialogTitle>
            {!addPopup.id ? (
              <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <TextField
                    {...register('name', { required: true })}
                    margin="normal"
                    label="Unit Name"
                    fullWidth
                  />

                  <TextField
                    {...register('code', { required: true })}
                    margin="normal"
                    label="Unit Code"
                    fullWidth
                  />

                  <TextField
                    {...register('baseMultiplier', { required: true })}
                    margin="normal"
                    type="number"
                    label="Base Multiplier"
                    fullWidth
                  />

                  <Button variant="contained" color="primary" type="submit">
                    Submit
                  </Button>
                </form>
              </DialogContent>
            ) : (
              <>
                <DialogContent>Are you sure to delete this Unit?</DialogContent>
                <DialogActions>
                  <Button onClick={handleClose} autoFocus>
                    cancel
                  </Button>
                  <Button
                    onClick={async () => {
                      const res = await deleteIngredientUnitApi(addPopup?.id);
                      if (res.status == 200) {
                        dispatch(
                          addSnackbar({
                            message: 'Unit Deleted',
                            type: 'warning'
                          })
                        );
                        handleClose();
                        callFunc();
                      } else {
                        dispatch(
                          addSnackbar({
                            message: res.response.data.message,
                            type: 'error'
                          })
                        );
                      }
                    }}>
                    Delete
                  </Button>
                </DialogActions>
              </>
            )}
          </Box>
        </Dialog>
      </Container>
    </Box>
  );
};

export default AddEditUnit;
